module.exports = __webpack_public_path__ + "img/144.997618a1.png";